export type LoginNoticeKey = 'invite-expired';

export interface LoginNotice {
  title: string;
  body: string;
}

export const LOGIN_NOTICE_PARAM = 'notice';

export const LOGIN_NOTICES: Record<LoginNoticeKey, LoginNotice> = {
  'invite-expired': {
    title: 'Invitation expired',
    body: "If you've already verified your account, log in below. Otherwise, ask your hub administrator to send you a new invitation.",
  },
};

export const LOGIN_INVITE_EXPIRED_PATH = `/login?${LOGIN_NOTICE_PARAM}=invite-expired`;

export function resolveLoginNotice(value: string | null): LoginNotice | undefined {
  if (!value || !Object.prototype.hasOwnProperty.call(LOGIN_NOTICES, value)) {
    return undefined;
  }
  return LOGIN_NOTICES[value as LoginNoticeKey];
}
